export default "__VITE_ASSET__41fU3qWx__"